const moment = require('moment-timezone');

export let timezones = []
const zoneKeys = moment.tz.names()
for (let i = 0; i < zoneKeys.length; i++) {
  const id = zoneKeys[i];
  const name = id.replace('_', ' ')
  timezones.push({ id, name })
}

export const supportedRoles = [
    "accountant",
    "administrativeassistant",
    "businessanalyst",
    "businessdevelopmentprofessional",
    "businessownerorfounder",
    "customersupportrepresentative",
    "datascientistanalystengineer",
    "designer",
    "devopsengineer",
    "facilitiespropertymanager",
    "financialadvisor",
    "fitnesscoach",
    "healthprofessional",
    "hrprofessional",
    "itprofessional",
    "legalprofessional",
    "marketingspecialist",
    "officemanager",
    "operationsprofessional",
    "presidentorceo",
    "productmanager",
    "projectmanager",
    "prprofessional",
    "realestateagent",
    "salesperson",
    "schooladministrator",
    "softwarewebmobileengineer",
    "student",
    "teacherorprofessor",
    "writeroreditor"
]

export const supportedIndustries = [
    "administrativeandsupport",
    "advertising",
    "agricultureandforestry",
    "apparel",
    "architecture",
    "automotive",
    "biotechnology",
    "commercialservices",
    "construction",
    "consumergoods",
    "consulting",
    "cosmetics",
    "design",
    "education",
    "financeandbanking",
    "foodandbeverages",
    "governmentandpublicservice",
    "healthcare",
    "hotelsandrestaurants",
    "hrandemploymentservices",
    "insurance",
    "leisureandsports",
    "logistics",
    "management",
    "manufacturing",
    "publishingandbroadcasting",
    "realestate",
    "researchservices",
    "retailandecommerce",
    "technology",
    "telecommunications",
    "transportation",
    "utilities"
]

export const globalState = {
    user: {}
}